import { render, staticRenderFns } from "./AssignRouteToDriverModal.vue?vue&type=template&id=826b9e96&"
import script from "./AssignRouteToDriverModal.vue?vue&type=script&lang=js&"
export * from "./AssignRouteToDriverModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports